import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const CheesecakeFields = ({ item, updateItem, cheesecakes }) => {
  // Extract unique flavors from all cheesecakes
  const getAvailableCheesecakeFlavors = () => {
    const unique = [
      ...new Set(cheesecakes.map((c) => c.flavor).filter(Boolean)),
    ];
    return unique.map((flavor) => ({ name: flavor, displayName: flavor }));
  };

  // Extract unique sizes from all cheesecake objects
  const getAvailableCheesecakeSizes = () => {
    const seen = new Set();
    const allSizes = cheesecakes.flatMap((c) => c.sizes || []);

    const uniqueSizes = allSizes.filter((s) => {
      const id = s._id?.toString();
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });

    return uniqueSizes;
  };

  const handleFlavorChange = (e) => {
    const selectedFlavorName = e.target.value;
    if (!selectedFlavorName) return;

    // Try to find a matching cheesecake by flavor
    const matchingCheesecake = cheesecakes.find(
      (c) => c.flavor === selectedFlavorName
    );

    updateItem(item._id, {
      flavor: {
        name: selectedFlavorName,
        displayName: selectedFlavorName,
      },
      image: matchingCheesecake?.images?.primary || "", // auto-fill image
    });
  };

  const handleSizeChange = (e) => {
    const selectedSize = getAvailableCheesecakeSizes().find(
      (s) => s._id?.toString() === e.target.value
    );

    if (!selectedSize) return;

    updateItem(item._id, {
      size: {
        _id: selectedSize._id,
        name: selectedSize.displayName || selectedSize.name, // ✅ use displayName
        tierCount: selectedSize.tierCount ?? null,
      },
    });
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Flavor"
          value={item.flavor?.name || ""}
          onChange={handleFlavorChange}>
          <MenuItem value="">
            <em>Select a flavor</em>
          </MenuItem>
          {getAvailableCheesecakeFlavors().map((f) => (
            <MenuItem key={f.name} value={f.name}>
              {f.displayName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Size"
          value={item.size?._id || ""}
          onChange={handleSizeChange}>
          {getAvailableCheesecakeSizes().map((s) => (
            <MenuItem key={s._id} value={s._id}>
              {s.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
};

export default CheesecakeFields;
